import { useMemo } from "react";
import { useAuth } from "../app/useAuth";
import { useFirestoreCollection } from "./useFirestoreCollection";
import { incomingActiveAvailabilitySharesQuery } from "../lib/data/availability-shares";

/**
 * Phase 4b — real-time listener over the signed-in user's *incoming*
 * availability shares (i.e. friends sharing their calendar TO this user).
 *
 * Used by the Create/Edit Poll page to determine which friends are
 * eligible to be added as overlay sources. Returns the same shape as
 * useOutgoingAvailabilityShares, plus a derived map keyed by ownerId so
 * the overlay picker can do an O(1) "is owner X sharing with me?" check.
 */
export function useIncomingAvailabilityShares() {
  const { user } = useAuth();
  const viewerId = user?.uid || null;

  const queryRef = useMemo(
    () => (viewerId ? incomingActiveAvailabilitySharesQuery(viewerId) : null),
    [viewerId],
  );

  const { data, loading, error } = useFirestoreCollection(queryRef);

  const sharesByOwnerId = useMemo(() => {
    const map = {};
    for (const share of data) {
      if (share?.ownerId) map[share.ownerId] = share;
    }
    return map;
  }, [data]);

  return { shares: data, sharesByOwnerId, loading, error };
}
